/**
 * 舆情主页管理路由
 */
export default [
  {
    path: "/sentimentNoRecharge",
    name: "sentimentNoRecharge",
    component: () => import("@/views/publicSentiment/noRecharge.vue"),
    meta: {
      title: "route.sentiment",
      crumbs: "route.social-monitor-crumb",
      isLogin: true,
    },
  },
  {
    path: "/sentiment",
    name: "publicSentiment",
    redirect: "/sentiment/social",
    component: () => import("@/views/publicSentiment/socialMedia/navigation.vue"),
    // component: () => import("@/views/publicSentiment/index.vue"),
    meta: {
      title: "route.sentiment",
      crumbs: "route.social-monitor-crumb",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航。
      sidebar: { label: "社媒监控", labelKey: "route.social-monitor", icon: "Monitor", order: 20 },
    },
    children: [
      {
        path: "/sentiment/social",
        name: "sentimentSocialMedia",
        // component: () => import("@/views/publicSentiment/socialMedia/index.vue"),
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/index.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.monitor-list-crumb",
          isLogin: true,
          // 二级导航同样由路由 meta 生成，详情页通过 activePaths 归属到该入口。
          sidebar: {
            label: "监控列表",
            labelKey: "route.monitor-list",
            icon: "Monitoring list",
            order: 10,
            // TikTok、INS、YouTube 新版详情都使用独立绝对路径，仍归属到“监控列表”二级菜单高亮。
            activePaths: [
              "/sentiment/social",
              "/socialMediaMonitoring/monitoringList/facebook-platform",
              // X 的新版主页与单帖详情入口均归属到“监控列表”侧栏项。
              "/socialMediaMonitoring/monitoringList/x-platform",
              "/socialMediaMonitoring/monitoringList/x-platform/post-detail",
              "/socialMediaMonitoring/monitoringList/tiktok-platform",
              "/socialMediaMonitoring/monitoringList/ins-platform",
              "/socialMediaMonitoring/monitoringList/youtube-platform",
            ],
          },
        },
      },
      {
        path: "/sentiment/dataSummary",
        name: "sentimentSocialDataSummary",
        component: () => import("@/views/publicSentiment/socialMedia/dataSummary.vue"),
        meta: {
          title: "route.data-summary",
          crumbs: "route.data-summary-crumb",
          isLogin: true,
          sidebar: { label: "数据汇总", labelKey: "route.data-summary", icon: "Analysis", order: 20 },
        },
      },

      {
        // 舆情-主页管理-主页详情
        path: "/sentiment/social/detail",
        name: "PlatformAccountData",
        component: () => import("@/views/publicSentiment/socialMedia/details/PlatformAccountData.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.monitor-detail-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 舆情 - 社媒监控 - 单一帖文详情
        path: "/sentiment/social/signalPostDetail",
        name: "SignalPostDetail",
        component: () => import("@/views/publicSentiment/socialMedia/details/SignalPostDetail.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.signal-post-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - X 平台；新版主页数据遵循 X 专用的当天数据截止规则。
        path: "/socialMediaMonitoring/monitoringList/x-platform",
        name: "X-platform",
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/X/XIndex.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "JoinMC - 社媒监控 - X 平台",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - X 帖子详情；独立路由保留新版单帖列表的筛选、排序和分页上下文。
        path: "/socialMediaMonitoring/monitoringList/x-platform/post-detail",
        name: "XSignalPostDetailNew",
        component: () =>
          import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/X/XSignalPostDetail.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "JoinMC - 社媒监控 - X 帖子详情",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - Facebook 平台；主页、粉丝、帖子和单一帖文页签共用该入口。
        path: "/socialMediaMonitoring/monitoringList/facebook-platform",
        name: "Facebook-platform",
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/FB/FacebookIndex.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.facebook-platform-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - tiktok 平台
        path: "/socialMediaMonitoring/monitoringList/tiktok-platform",
        name: "TikTok-platform",
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/TIKTOK/TikTokIndex.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.tiktok-platform-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - INS 平台；页面结构预留给新版 INS 数据模块。
        path: "/socialMediaMonitoring/monitoringList/ins-platform",
        name: "Ins-platform",
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/INS/InsIndex.vue"),
        meta: {
          title: "社媒监控",
          crumbs: "JoinMC - 社媒监控 - INS 平台",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - YouTube 平台；沿用新版详情页的工具栏、数据页签和账号侧栏布局。
        path: "/socialMediaMonitoring/monitoringList/youtube-platform",
        name: "YouTube-platform",
        component: () => import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/YOUTUBE/YouTubeIndex.vue"),
        meta: {
          title: "社媒监控",
          crumbs: "JoinMC - 社媒监控 - YouTube 平台",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // YouTube 独立帖子详情，与 INS 并列；旧通用详情路由保留给其它平台。
        path: "/socialMediaMonitoring/monitoringList/youtube-platform/post-detail",
        name: "YouTubeSignalPostDetailNew",
        component: () =>
          import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/YOUTUBE/YouTubeSignalPostDetail.vue"),
        meta: {
          title: "社媒监控",
          crumbs: "JoinMC - 社媒监控 - YouTube 帖子详情",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - Facebook 帖文详情；使用新版独立地址，不再复用旧 SignalPostDetail。
        path: "/socialMediaMonitoring/monitoringList/facebook-platform/post-detail",
        name: "FacebookSignalPostDetailNew",
        component: () =>
          import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/FB/FacebookSignalPostDetailNew.vue"),
        meta: {
          title: "route.social-monitor",
          // 浏览器标签直接使用可读标题，避免缺失 i18n key 时显示 route.facebook-post-crumb。
          crumbs: "JoinMC - 社媒监控 - Facebook 帖子详情",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - tiktok 帖文详情
        path: "/socialMediaMonitoring/monitoringList/tiktok-platform/post-detail",
        name: "TikTokSignalPostDetailNew",
        component: () =>
          import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/TIKTOK/TikTokSignalPostDetail.vue"),
        meta: {
          title: "route.social-monitor",
          crumbs: "route.tiktok-post-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // JoinMC - 社媒监控 - INS 帖子详情
        path: "/socialMediaMonitoring/monitoringList/ins-platform/post-detail",
        name: "InsSignalPostDetailNew",
        component: () =>
          import("@/views/SocialMediaMonitoring/MonitoringList/platformComponents/INS/InsSignalPostDetail.vue"),
        meta: {
          title: "社媒监控",
          crumbs: "JoinMC - 社媒监控 - INS 帖子详情",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
    ],
  },
];
